import React from 'react';
import { BuildingIcon, GraduationCapIcon, PresentationIcon, ScissorsIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [ScissorsIcon, GraduationCapIcon, BuildingIcon, PresentationIcon];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-38" data-mp="1t8qvunmllrdf">
      <div className="mx-auto max-w-5xl" data-id="element-39" data-mp="2858b3pxwrq59">
        <SectionHeading id="audience-heading" eyebrow="Idéal pour" title={<>
              Conçu pour les professionnels <Accent data-id="element-41" data-mp="2gylc7f64ly2f">qui enseignent le barbering.</Accent>
            </>} data-id="element-40" data-mp="237q0zw85n4vo" />

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4" role="list" data-id="element-42" data-mp="2cyt1owx69huf">
          {audience.map((role, index) => {
          const Icon = icons[index];
          return <li key={role} className="flex flex-col items-center rounded-[20px] bg-brand-ivory px-4 py-7 text-center" data-id="element-43" data-mp="2lz8zbpr8hurd" data-mpi={index}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white" data-id="element-44" data-mp="1sdf423wt4ja7">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-45" data-mp="1xaxgi4a19gmy" />
                </span>
                <span className="mt-3 font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal sm:text-[1.35rem]" data-id="element-46" data-mp="22c4mbxsm85qz">
                  {role}
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-47" data-mp="2g901m7zgmtfh">
          Que vous organisiez vos premiers cours ou que vous perfectionniez une formation déjà
          établie — <strong className="font-semibold text-brand-charcoal" data-id="element-48" data-mp="2pyt9axwheoeg">ce système vous apporte des ressources pratiques à adapter à vos élèves.</strong>
        </p>
      </div>
    </section>;
}